<template>
  <div>
    <div class="relative">
      <div
        v-if="isOpen"
        class="fixed pin z-4"></div>
      <drawer-transition>
        <div
          v-if="isOpen"
          :id="`filters-drawer-${formattedTitle}`"
          class="fixed top-0 right-0 bottom-0 filters-drawer bg-paper-1 flex flex-col drawer-right">
          <div
            class="overflow-auto drawer-height md:p-4 justify-betweeen items-center cursor-pointer filter-checkbox-container">
            <div class="flex justify-between pr-5">
              <div
                class="p-5 flex cursor-pointer justify-center items-center"
                @click="$emit('closeActiveDrawer')">
                <svg-icon
                  class="mr-4 items-center"
                  name="leftarrow-small-thin"
                  height="12px"
                  width="12px" />
                <p
                  class="underline cursor-pointer self-center"
                  data-cy="back-to-all-filters">
                  {{ t("category.all-filters") }}
                </p>
              </div>
              <div
                class="cursor-pointer self-center"
                data-cy="close-filter-panel"
                @click="closeDrawers">
                <svg-icon
                  height="24px"
                  width="24px"
                  name="close-display" />
              </div>
            </div>
            <div class="mb-2 pb-8 md:pb-0">
              <h3
                data-cy="filter-title"
                class="typeset-3 px-5 pt-6 pb-4 mb-4">
                {{ activeFilter.title }}
              </h3>
              <div
                v-for="(option, index) in sortedOptions"
                :key="option.name"
                class="flex px-5 py-4 justify-betweeen items-center cursor-pointer filter-checkbox-container"
                @click="triggerHandleChange(option)">
                <checkbox-input
                  v-model:checked="option.active"
                  :input-id="`${activeFilter.key}-${index}`"
                  class="mr-4"
                  filters-checkbox />
                <span
                  v-if="option.hex"
                  class="filter-colour-swatch br-circle mr-4 flex-no-shrink"
                  :class="{
                    'filter-colour-swatch--light': swatchIsLight(option)
                  }"
                  :style="swatchStyle(option)"></span>
                <h5 class="cursor-pointer">
                  {{ option.name }}
                  <span
                    :data-cy="`choose-${option.name
                      .replaceAll(' ', '-')
                      .toLowerCase()}`"
                    class="ml-3 text-ink-3 cursor-pointer">
                    ({{ option.count }})
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </drawer-transition>
    </div>
  </div>
</template>

<script>
import CheckboxInput from "../components/shared/CheckboxInput.vue";
import SvgIcon from "../components/shared/SvgIcon.vue";
import DrawerTransition from "../components/transitions/DrawerTransition.vue";

export default {
  name: "ActiveFilterDrawer",
  components: {
    SvgIcon,
    CheckboxInput,
    DrawerTransition
  },
  props: {
    activeFilter: {
      type: Object,
      required: false,
      default: () => {}
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ["closeDrawers", "clearFilters", "handleChange", "closeActiveDrawer"],
  computed: {
    sortedOptions() {
      return [...this.activeFilter.options].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    formattedTitle() {
      return this.activeFilter?.title.replaceAll(" ", "-").toLowerCase();
    },
    swatchColour() {
      return hex => `#${hex.replace("#", "")}`;
    },
    gradientSwatch() {
      return key =>
        ({
          multi:
            "conic-gradient(from 0deg, #e64b3c, #e6d13c, #57c84d, #3cc9c9, #4b5fe6, #a04be6, #e64b3c)",
          gold: "linear-gradient(135deg, #b8860b 0%, #e6c15a 40%, #f7e7b0 70%, #c9a53b 100%)"
        })[key];
    },
    swatchStyle() {
      return option => {
        const gradient = this.gradientSwatch(option.swatch_key);
        return gradient
          ? { backgroundImage: gradient }
          : { backgroundColor: this.swatchColour(option.hex) };
      };
    },
    swatchIsLight() {
      return option => option.light && !this.gradientSwatch(option.swatch_key);
    }
  },
  methods: {
    closeDrawers() {
      this.$emit("closeDrawers");
    },
    triggerHandleChange(option) {
      if (!option.active) {
        analytics.track("Clicked Filter", {
          name: this.activeFilter.title,
          value: option.name
        });
      }
      option.active = !option.active;
      this.$emit("handleChange");
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-colour-swatch {
  width: 1.5rem;
  height: 1.5rem;
}

.filter-colour-swatch--light {
  box-shadow: inset 0 0 0 1px var(--ink-3);
}
</style>
